import React,{useState} from "react";
import './charts.css'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
import { useSelector } from "react-redux";
import { selectBuckets, selectCurrentDate } from "../../components/buckets/slice/buckets";
import { filteredBucketList } from "../../components/buckets/slice/lucket-model/filterBuckets";
import { STATUS_OPTION, STEP_OPTION, TIMEFRAME, statusOptions } from "../../components/buckets/constants";
import { DayStatus } from "./individualCharts/DayStatus.cmp";
import { WeekPoints } from "./individualCharts/WeekPoints.cmp";
import { DayPoints } from "./individualCharts/DayPoints";
import { WeekStatus } from "./individualCharts/WeekStatus.cmp";
import TotalPointsByDay from "./individualCharts/TotalPointsByDay.cmp";
import { Button } from "@mui/material";
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );
export function Charts(){
    const buckets = useSelector(selectBuckets);
    const currentDate = useSelector(selectCurrentDate);
    const [chartTimeframe, setChartTimeframe] = useState("max")
    let filteredBuckets = filteredBucketList(buckets, STEP_OPTION.Do, TIMEFRAME.Day, currentDate)
    let filteredBucketsWeek = filteredBucketList(buckets, STEP_OPTION.Do, TIMEFRAME.Week, currentDate)
    let planBuckets = filteredBucketList(buckets, STEP_OPTION.Plan, "N/A", currentDate).filter(l=>!l.parentRowID)
    let lucketHistory = planBuckets.reduce((acc,planLucket,i) => {
      let planBucketHistory = buckets.filter(l=>!l.parentRowID).reduce((acc2,lucket)=>{
        if(lucket.name == planLucket.name){
          acc2.push(lucket)
        }
        return acc2
      },[]) 
      acc.push(planBucketHistory)
      return acc
    },[]);
    console.log("sup lucket history", lucketHistory)
    console.log("hi filteredBucketsWeek",filteredBucketsWeek)
    return <div>
      <div className="chartsContainer">
        <div className="chart">
          <DayStatus filteredBuckets={filteredBuckets}/>
        </div>

        <div className="chart">
          <DayPoints filteredBuckets={filteredBuckets} filteredBucketsWeek={filteredBucketsWeek}/> 
        </div>

        
        <div className="chart">
          <WeekStatus filteredBuckets={filteredBucketsWeek}/>
        </div>
        <div className="chart">
          <WeekPoints filteredBuckets={filteredBucketsWeek}/> 
        </div>
      </div>
      <div className="chartsContainer" style={{flexDirection:"column"}}>
          <div>
            <Button variant={chartTimeframe=="max"?"contained":"outlined"} color={"primary"} onClick={()=>{
              setChartTimeframe("max")
            }}>
              max
            </Button>
            <Button variant={chartTimeframe=="week"?"contained":"outlined"} color={"primary"} onClick={()=>{
              setChartTimeframe("week")
            }}>
              week
            </Button>
            <Button variant={chartTimeframe=="month"?"contained":"outlined"} color={"primary"} onClick={()=>{
              setChartTimeframe("month")
            }}>
              month
            </Button>
          </div>
          
          <TotalPointsByDay chartTimeframe={chartTimeframe} allLuckets={buckets}/>
      </div>
    </div>
}